<unity-link-shared [variants]="['boldblue', 'centered']" [displayText]="$displayText()" [link]="$link()" />
